// Masked form shown to anonymous users who haven't revealed yet, so Googlebot
// (cookieless, never clicks) never sees a real code in the rendered DOM. Mirrors
// the backend `maskCode` style (`*****` + last 2 chars); short codes are fully
// masked so we don't leak most of the value.
export function maskCode(code: string): string {
  return code.length < 4 ? "*****" : `*****${code.slice(-2)}`;
}
